var _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M5.571,10.017A5.088,5.088,0,0,1,5.6,9.452l-2.89-.943A8.062,8.062,0,0,0,5.1,15.873l1.786-2.467A5.012,5.012,0,0,1,5.571,10.017Zm10,0a5.012,5.012,0,0,1-1.312,3.389l1.786,2.467a8.062,8.062,0,0,0,2.384-7.364l-2.89.943A5.1,5.1,0,0,1,15.571,10.017Zm-4-4.919a5.008,5.008,0,0,1,3.351,2.444l2.89-.943a8.009,8.009,0,0,0-6.241-4.551ZM6.22,7.542A5.008,5.008,0,0,1,9.571,5.1V2.048A8.009,8.009,0,0,0,3.33,6.6l2.89.943Zm6.422,7.044a4.994,4.994,0,0,1-4.142,0L6.714,17.054a7.981,7.981,0,0,0,7.714,0Z",
    transform: "translate(-2.571 -2.048)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPending);
export default __webpack_public_path__ + "static/media/icon-pending.4bede435a9e9a925e5dc499476d5f75e.svg";
export { ForwardRef as ReactComponent };